import { BankAccountType } from "../../components/form/bank-account";

export const BANK_DETAILS = "bankDetails";

export function getBankSVGLines({
  name,
  bank,
  branch,
  account,
  suffix,
}: BankAccountType) {
  if (!name) {
    return [];
  }

  return [
    { heading: "Pēke - Bank" },
    { label: "Name", text: name },
    {
      label: "Number",
      text: `${bank} ${branch} ${account} ${suffix}`,
    },
  ];
}
